import { createStyles, makeStyles, Theme } from '@material-ui/core';

import { SMALL_MARGIN, colorsPalette } from '../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cardWrapper: {
      borderRadius: 10,
      background: theme.palette.secondary.light,
      paddingBottom: 24,
      maxWidth: 343,
      minWidth: 288,
      width: '100%',
      marginBottom: SMALL_MARGIN,
      height: 250,
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
      [theme.breakpoints.up('md')]: {
        width: 318,
        paddingBottom: 32,
      },
      '&:last-child': {
        marginBottom: 0,
      },
    },
    imageWrapper: {
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
      height: 179,
      overflow: 'hidden',
      display: 'flex',
      '&::after': {
        cursor: 'pointer',
        content: '""',
        display: 'block',
        position: 'absolute',
        bottom: 0,
        left: 0,
        height: 136,
        width: '100%',
        zIndex: 2,
        background:
          'linear-gradient(0deg, #23202E 0%, rgba(36, 34, 47, 0.901961) 17.24%, rgba(45, 50, 56, 0.0001) 100%)',
      },
    },
    previewImg: {
      cursor: 'pointer',
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      borderRadius: '10px 10px 0 0',
    },
    playBtnWrap: {
      cursor: 'pointer',
      position: 'absolute',
      transform: 'translate(-50%, -60%)',
      background: 'rgba(29, 29, 41, 0.501961);',
      top: '50%',
      left: '50%',
      zIndex: 5,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '50%',
      width: 50,
      height: 50,
      [theme.breakpoints.up('md')]: {
        width: 70,
        height: 70,
      },
    },
    btn: {
      width: 24,
      height: 28,
      marginLeft: 2,
      transition: 'all .3s',
      [theme.breakpoints.up('md')]: {
        width: 35,
        height: 40,
        marginLeft: 4,
      },
    },
    categoryWrapper: {
      display: 'flex',
      padding: '0 24px',
      marginBottom: 12,
      zIndex: 2,
      [theme.breakpoints.up('md')]: {
        padding: '0 32px',
      },
      '& > div:nth-child(2)': {
        marginLeft: 10,
      },
    },
    textWrapper: {
      padding: '0px 24px',
      zIndex: 2,
      [theme.breakpoints.up('md')]: {
        padding: '0 32px',
      },
    },
    title: {
      fontSize: 14,
      fontWeight: 'bold',
      lineHeight: 1.2,
      color: colorsPalette.white,
      marginBottom: 12,
      overflow: 'hidden',
      whiteSpace: 'inherit',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      '-webkit-line-clamp': '1',
      '-webkit-box-orient': 'vertical',
      [theme.breakpoints.up('sm')]: {
        fontSize: 20,
        lineHeight: '28px',
      },
    },
    subtitle: {
      fontSize: 12,
      lineHeight: 1,
      color: colorsPalette.violet,
      '& > a': {
        color: colorsPalette.violet,
      },
      [theme.breakpoints.up('md')]: {
        fontSize: 14,
        lineHeight: '18px',
      },
    },
    catName: {
      maxWidth: 200,
      zIndex: 3,
    },
    infoRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  }),
);

export default useStyles;
